var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldchainLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9 4.8C48.4 1.6 42.4 0 35.9 0C29.4 0 23.4 1.6 17.9 4.8C12.4 8 8 12.4 4.8 17.9C1.6 23.4 0 29.4 0 35.9C0 42.4 1.6 48.4 4.8 53.9C8 59.4 12.4 63.8 17.9 67C23.4 70.2 29.4 71.8 35.9 71.8C42.4 71.8 48.4 70.2 53.9 67C59.4 63.8 63.8 59.4 67 53.9C70.2 48.4 71.8 42.4 71.8 35.9C71.8 29.4 70.2 23.4 67 17.9C63.8 12.4 59.4 8 53.9 4.8ZM38.1 48.9C34 48.9 30.8 47.7 28.3 45.4C26.6 43.8 25.5 41.9 25 39.6H63.8C63.4 42.9 62.4 46 61 48.9H38.2H38.1ZM25 32.3C25.5 30.1 26.6 28.1 28.3 26.5C30.8 24.2 34 23 38.1 23H61C62.5 25.9 63.4 29 63.8 32.3H25ZM11.6 21.6C14.1 17.3 17.5 13.8 21.8 11.3C26.1 8.8 30.8 7.5 36 7.5C41.2 7.5 45.9 8.8 50.2 11.3C52.4 12.6 54.3 14.1 56.1 15.9H38C33.9 15.9 30.2 16.8 27 18.5C23.8 20.2 21.3 22.6 19.6 25.6C18.4 27.7 17.6 30 17.2 32.4H8.3C8.7 28.6 9.9 25 11.8 21.7L11.6 21.6ZM50.1 60.5C45.8 63 41.1 64.3 35.9 64.3C30.7 64.3 26 63 21.7 60.5C17.4 58 14 54.5 11.5 50.2C9.6 46.9 8.4 43.4 8 39.6H16.9C17.3 42 18.1 44.3 19.3 46.4C21.1 49.4 23.6 51.7 26.7 53.5C29.9 55.2 33.6 56.1 37.7 56.1H55.7C54 57.8 52.1 59.3 50 60.5H50.1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldchainLight);
export default __webpack_public_path__ + "static/media/worldchain_light.018ace6aa561dbc4af51ed588bd51179.svg";
export { ForwardRef as ReactComponent };